import { apiClient } from "~/lib/utils/axios";
import {
  IGetTransactionsParam,
  ITransactionV3,
} from "~/lib/types/payment.type";
import { GetOneTransaction } from "~/lib/types/variables.type";

export const getIndexTransactions = (params?: IGetTransactionsParam) => {
  return apiClient
    .get(
      `/payments/transactions?from=${params?.from}&view=v3&perPage=${
        params?.perPage || 20
      }&page=${params?.page || 1}`
    )
    .then((response) => {
      let transactionsData: ITransactionV3[] = response.data;

      if (params?.referenceType) {
        transactionsData = transactionsData.filter(
          (trx) => trx.referenceType === params?.referenceType
        );
      }

      return transactionsData;
    });
};

export const getOneTransaction = (params?: GetOneTransaction) => {
  return apiClient
    .get(`/payments/transactions/${params?.id}`)
    .then((response) => response.data);
};

export const getSessionParking = (referenceId: string) => {
  return apiClient
    .get(`/parking/sessions/${referenceId}`)
    .then((response) => response.data);
};

export const getListPaymentMethods = () => {
  return apiClient
    .get(`/payments/payment-methods?getBalanceInfo=true`)
    .then((response) => response.data);
};
